import { ValueProps } from '@/lib/interface';
import { SparklesIcon } from 'lucide-react';
import React from 'react';

export default function ValuePropsComponent({ valueProps, spark=false }: { valueProps: ValueProps, spark?:boolean }) {
  return (
    <div>
      <div className="mt-20 max-w-3xl pb-12 md:pb-20">
      {spark && <a
                className="mb-4 md:mb-8  group-hover:-translate-y-0.5 btn-sm py-0.5 bg-primary/10 !border !border-primary/25 text-primary hover:text-gray-300 transition delay-100 duration-500    xl:animate-fade-in-down    relative "
                href=""
              >
                <span className="relative inline-flex items-center text-sm ">
                  <SparklesIcon className="w-4 mr-2" />
                  Introducing Mendable.ai for Sales
                </span>
              </a>}
        <h2 className="h2 bg-clip-text text-transparent bg-gradient-to-r from-gray-100/60 via-gray-100 to-gray-100/60 pb-4">
          {valueProps.title}
        </h2>
        <p className="text-lg text-gray-300">{valueProps.description}</p>
      </div>

      {valueProps.sectionProps.map((s) => (
        <div key={s.title} className="divide-y divide-gray-800">
          {/* Row */}
          <div className="py-8 first-of-type:pt-0 last-of-type:pb-0">
            <div>
              <div className="inline-flex font-medium bg-clip-text text-transparent bg-gradient-to-r from-purple-500 to-purple-100 pb-6">
                {s.title}
              </div>
            </div>
            <div className="grid md:grid-cols-3 gap-8 md:gap-12 mb-2">
              {/* Feature */}
              {s.individualProps.map((i) => (
                <div key={i.title}>
                  <div className="flex items-center space-x-2 mb-1">
                    {i.icon}
                    <h4 className="font-medium text-gray-50">{i.title}</h4>
                  </div>
                  <p className="text-sm text-gray-400">{i.description}</p>
                </div>
              ))}
              {/* Feature */}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
